import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Logo from "../../images/logo.svg";
import React, { Fragment } from "react";
import "./PaymentPage.css";
import { t } from "i18next";
const PaymentSTCPayPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderid");
  const amount = Number(searchParams.get("amount")) * 100; // Convert to cents
  const navigate = useNavigate();
  const paymentRef = useRef(null);

  // ✅ Log to check if env variable is set
  console.log("BASE_URL:", process.env.REACT_APP_BASE_URL);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (window.Moyasar && paymentRef.current) {
      window.Moyasar.init({
        element: paymentRef.current,
        amount: amount,
        currency: "SAR",
        description: "Order Payment",
        publishable_api_key: "pk_test_Ay4UNWEWdZQ3AwAZHNTrUqX52mmLJDUGxVWZ5BhC", //process.env.MOYASAR_PUBLISHABLE_KEY,
        callback_url: `${BASE_URL}/order_received?orderid=${orderId}&amount=${amount}`,
        methods: ["stcpay"],
        on_completed: async (payment) => {
          console.log("Payment Completed:", payment);
          // Send data to backend
          await fetch(`${BASE_URL}/order_received`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              payment_id: payment.id,
              order_id: orderId,
              status: payment.status,
            }),
          });

          // Redirect after payment
          navigate(
            `/order_received?orderid=${orderId}&status=${payment.status}`
          );
        },
      });
    }
  }, [orderId, amount, navigate, BASE_URL]);

  return (
    <Fragment>
      <div className="logo-container">
        <Link to="/home">
          <img src={Logo} alt="logo" className="app-logo" />
        </Link>
      </div>
      <div className="payment-container">
        <div className="payment-header">
          <h2>{t("paymentDetails")}</h2>
          <p>
            {t("totalAmount")}: {amount / 100} {t("currency")}
          </p>
        </div>
        <div ref={paymentRef} className="mysr-form"></div>
      </div>
    </Fragment>
  );
};

export default PaymentSTCPayPage;
